import React from 'react';
const articles = [{
  kicker: 'תרבות',
  title: 'האסתטיקה של השקט',
  dek: 'איך עיצוב מינימליסטי הפך מתנועת נגד למיינסטרים מסחרי, ומה איבדנו בדרך.',
  author: 'יונתן כהן'
}, {
  kicker: 'מחשבה',
  title: 'מעבר למסך',
  dek: 'פילוסופיה של תשומת לב בעידן של הסחות דעת בלתי פוסקות. קריאת כיוון.',
  author: 'ד״ר יעל שטרן'
}, {
  kicker: 'אמנות',
  title: 'צבעים של זיכרון',
  dek: 'תערוכה חדשה בוחנת את הקשר בין פיגמנטים עתיקים לטראומה קולקטיבית.',
  author: 'מיכל אהרוני'
}];
export function Featured() {
  return <section className="px-4 md:px-8 py-16 md:py-24 border-b border-ink/20" data-id="element-25">
      <div className="max-w-7xl mx-auto" data-id="element-26">
        <div className="flex justify-between items-end mb-12 border-b border-ink/20 pb-4" data-id="element-27">
          <h3 className="font-sans text-2xl font-bold text-ink" data-id="element-28">
            קריאה מומלצת
          </h3>
          <a href="#" className="font-sans text-sm font-medium text-vermillion hover:text-ink transition-colors" data-id="element-29">
            לכל המאמרים ←
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12" data-id="element-30">
          {articles.map((article, i) => <article key={i} className="group cursor-pointer flex flex-col h-full" data-id="element-31">
              <div className="font-sans text-xs font-bold tracking-kicker text-vermillion uppercase mb-4" data-id="element-32">
                {article.kicker}
              </div>
              <h4 className="font-serif text-3xl md:text-4xl font-bold leading-tight text-ink mb-4 group-hover:text-vermillion transition-colors relative inline-block" data-id="element-33">
                {article.title}
              </h4>
              <p className="font-sans text-base text-ink-soft mb-8 flex-grow" data-id="element-34">
                {article.dek}
              </p>

              <div className="mt-auto pt-4 border-t border-ink/10 flex justify-between items-center" data-id="element-35">
                <span className="font-sans text-sm text-ink-soft/80" data-id="element-36">
                  {article.author}
                </span>
                <span className="font-sans text-sm font-medium text-ink group-hover:text-vermillion transition-colors" data-id="element-37">
                  המשך קריאה
                </span>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}